require('../src/td_shopify_embed/index');